import { defineStore } from 'pinia'
import { ref } from 'vue'

import { NotificationName, useNotificationsQueue } from '@/store/notification-que/notifications-queue'

export interface ToastOptions {
    type: NotificationName
    title: string
    description: string
    imageStyles?: Record<string, string>
    animation?: Record<string, unknown>
    isFullScreenAllowed?: boolean
    image?: string
    buttonText?: string
    priority: number
    showTimeoutMs?: number
    onAccept?: () => void
    onClose?: () => void
    onShow?: () => void
}

export const useToastStore = defineStore('toast', () => {
    const isVisible = ref(false)
    const toast = ref<ToastOptions | null>(null)
    const notificationsQueue = useNotificationsQueue()

    const showToast = (options: ToastOptions) => {
        notificationsQueue.request({
            name: options.type,
            priority: options.priority,
            onOpen: () => {
                toast.value = { ...options }
                isVisible.value = true
                options.onShow?.()
            },
            onClose: () => {
                isVisible.value = false
                toast.value = null
            },
        })
    }

    const closeToast = () => {
        if (toast.value) {
            notificationsQueue.remove(toast.value.type)
        }
    }

    const acceptToast = () => {
        if (toast.value) {
            toast.value.onAccept?.()
            notificationsQueue.remove(toast.value.type)
        }
    }

    return {
        toast,
        isVisible,
        showToast,
        closeToast,
        acceptToast,
    }
})
